import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { AuthService } from "src/app/auth.service";
import { ContactUsComponent } from '../hvacLocation/contactus/contactus.component';
import { MessagerComponent } from "../messager/messager/messager.component";
import { ContactUsService } from "../hvacLocation/contactus/contactus.service";
import { Router, ActivatedRoute, ParamMap, RouterModule } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-hvac-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HvacHomeComponent implements OnInit {
  title = 'home';

  constructor(public dialog: MatDialog, private fb:FormBuilder, public service: ContactUsService, private messager: MessagerComponent, private router: Router) {}
  fainfo = faInfoCircle;
  ngOnInit(): void {
  }

  openContactForm(): void {

    document.getElementById('main-nav').style.display = 'none';
    const dialogRef = this.dialog.open( ContactUsComponent, {
      panelClass: ['no-padding', 'no-scrolls', 'contactUs'],
      data: 'hello',
    });
    dialogRef.afterClosed().subscribe(result => {

      document.getElementById('main-nav').style.display = 'block';
    })

  }
  //undo the routerlink navigation triggered by clicking the area.
  stayHome(): void {
    setTimeout(() => {
     this.router.navigate(['/home']);
    }, 1000)
  }
}



